import { setSpecificMessage, emoji } from "valibot";
setSpecificMessage(
  emoji,
  (issue) => `Émoji invalide: reçu ${issue.received}`,
  "fr"
);